import React, { useEffect, useState } from "react";
import { Menu } from "semantic-ui-react";

import AccountInfo from "./AccountInfo";
import Dashboard from "./Dashboard";
import LoginForm from "./LoginForm";

function HomePage() {
  const [userInfo, setUserInfo] = useState(null);
  // we could also have allowable collections here...

  const children =
    userInfo === null ? (
      <>
        <div style={{ height: "100px" }}></div>
        <div className="ui icon info message">
          <i className="notched circle loading icon"></i>
          <div className="content">
            <div className="header">Welcome Altoids</div>
            <p>Checking if you're already logged in...</p>
          </div>
        </div>
        <div style={{ height: "400px" }}></div>
      </>
    ) : userInfo ? (
      <Dashboard userInfo={userInfo} />
    ) : (
      <LoginForm setUserInfo={setUserInfo} />
    );

  function logout() {
    fetch("/api/logout").then(() => setUserInfo(false));
  }

  function maybeGetUser() {
    fetch("/api/info").then((resp) => {
      if (resp.status === 200) {
        resp.json().then(setUserInfo);
      } else {
        setUserInfo(false);
      }
    });
  }
  // passing [] means this is only read once.
  useEffect(() => maybeGetUser(), []);

  const maybeLogoutButton = userInfo ? (
    <>
      <Menu.Item className="ui right">
        {<AccountInfo userInfo={userInfo} />}
      </Menu.Item>
      <Menu.Item as="button" className="ui button login" onClick={logout}>
        Log Out
      </Menu.Item>
    </>
  ) : (
    <></>
  );

  return (
    <>
      <Menu>
        <Menu.Item>
          <img alt="Altos" src="/profile-pic_121519a.png" />
        </Menu.Item>

        <Menu.Item as="a" href="/docs">
          Documentation
        </Menu.Item>

        <Menu.Item as="a" href="mailto:support@altosresearch.com">
          Support
        </Menu.Item>
        {maybeLogoutButton}
      </Menu>
      <div className="ui container">{children}</div>
    </>
  );
}

export default HomePage;
